export async function signin(user) {
  return await $fetch('/api/signin', {
    method: 'POST',
    body: JSON.stringify(user)
  })
}

export async function signout() {
  return await $fetch('/api/signout', {
    method: 'POST'
  })
}

export async function verifyRecaptcha(token, action) {
  const apiHeaders = await useApiHeaders(true)
  const data = await $fetch('/recaptcha', {
    ...apiHeaders,
    method: 'POST',
    body: JSON.stringify({ token, action })
  })
  return data.data
}

export async function userExists(email) {
  return await $fetch('/api/user-exists', {
    method: 'POST',
    body: JSON.stringify({ email })
  })
}

export async function firebaseUserExists(email, password) {
  return await $fetch('/api/firebase-user-exists', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  })
}

export async function signup(user) {
  return await $fetch('/api/signup', {
    method: 'POST',
    body: JSON.stringify(user)
  })
}

export async function updateUser(userData) {
  //remove subscription property from userData
  delete userData.subscription
  const apiHeaders = await useApiHeaders(true)

  const response = await $fetch('/api/user/' + userData.id, {
    ...apiHeaders,
    method: 'PUT',
    body: userData
  })

  return response || {}
}

export async function deleteUserFromApi(userId) {
  const apiHeaders = await useApiHeaders(true)
  const data = await $fetch('/api/user/' + userId, {
    ...apiHeaders,
    method: 'DELETE'
  })
  return data.data
}

export async function setup2fa(userid) {
  const apiHeaders = await useApiHeaders(true)
  const response = await $fetch('/api/user/' + userid + '/setup2fa', {
    ...apiHeaders,
    method: 'POST'
  })
  return response
}
export async function verify2fa(userid, token) {
  const apiHeaders = await useApiHeaders(true)
  const response = await $fetch('/api/user/' + userid + '/verify2fa', {
    ...apiHeaders,
    method: 'POST',
    body: JSON.stringify({ token })
  })

  return response.data || response
}

export function forgotPassword(email) {
  return apiClient.post('/forgot', { email }).then((data) => {
    return data.data
  })
}
export function resetPassword(resetData) {
  return apiClient.post('/reset', resetData)
}
export async function getNotifications() {
  const apiHeaders = await useApiHeaders(true)
  const response = await $fetch('/api/usernotification', {
    ...apiHeaders
  })
  return response
}

export async function markAsRead(ids, userid) {
  const apiHeaders = await useApiHeaders(true)
  const response = await $fetch(`/api/usernotification/${userid}/mark`, {
    ...apiHeaders,
    method: 'POST',
    body: { ids }
  })
  return response
}
